import * as React from "react";
const SvgDotG300 = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={18} height={18} fill="none" {...props}>
    <circle cx={9} cy={9} r={3} fill="#C8C8C8" />
  </svg>
);
export default SvgDotG300;
